import copy from '../../copy/en/shell.json' with { type: 'json' };
import { formatCopy } from '../../copy/format.js';
import { Link } from "react-router";
import { useTheme } from "../theme/index.js";
import { cx } from "../components/ui/cx.js";

/**
 * Brand lockup from the theme. Uses the published lockup when one exists for
 * the current mode; otherwise the mark plus a text wordmark in the display font
 * (the documented interim for ChairShare on light surfaces).
 */
export function Brand({ size = "md", sub, to = "/" }: { size?: "md" | "lg"; sub?: string; to?: string | null }) {
  const { theme, mode } = useTheme();
  const lockup = mode === "dark" ? theme.logo.lockupDark : theme.logo.lockupLight;
  const inner = lockup ? (
    <img className="brand__lockup" src={lockup} alt={theme.productName} />
  ) : (
    <>
      <img className="brand__mark" src={theme.logo.mark} alt="" aria-hidden />
      <span className="brand__wordmark">{theme.productName}</span>
    </>
  );
  const cls = cx("brand", size === "lg" && "brand--lg");
  const content = (
    <>
      {inner}
      {sub ? <span className="brand__sub">{sub}</span> : null}
    </>
  );
  if (to === null) return <span className={cls}>{content}</span>;
  return (
    <Link to={to} className={cls} aria-label={formatCopy(copy.Brand.homeLabel, { productName: theme.productName })}>
      {content}
    </Link>
  );
}
